const isMobile = /Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent);
class StarsSwiper extends HTMLElement {
    constructor() {
        super();
        const swiperContainer = this.querySelector('.stars-swiper')
        const swiperWrapper = swiperContainer.querySelector(".swiper-wrapper")
        
        const collectionSwiper = new Swiper(swiperContainer, {
            loop: false,
            slidesPerView: 1.8,
            spaceBetween: 11,
            allowTouchMove: true,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },

            breakpoints: {
                480: {
                    slidesPerView: 2.5,
                    spaceBetween: 15,
                    slidesPerGroup: 2,
                },
                576: {
                    slidesPerView: 3.5,
                    spaceBetween: 20,
                    slidesPerGroup: 3,
                },
                768: {
                    slidesPerView: 4.5,
                    spaceBetween: 28,
                    slidesPerGroup: 4,
                },
                1024: {
                    slidesPerView: 6.5,
                    spaceBetween: 31,
                    slidesPerGroup: 5,
                }
            }
        })

        collectionSwiper.on('slideChange', function () {
            if (collectionSwiper.activeIndex == 5) {
                swiperWrapper.classList.add("slider-moved")
            }

            if (!collectionSwiper.isEnd && swiperWrapper.classList.contains("slider-ended")) {
                swiperWrapper.classList.remove("slider-ended")
            }
        });

        collectionSwiper.on('sliderFirstMove', function () {
            swiperWrapper.classList.add("slider-moved")
        })

        collectionSwiper.on('reachBeginning', function () {
            if (swiperWrapper.classList.contains("slider-moved")) {
                swiperWrapper.classList.remove("slider-moved")
            }
        })

        collectionSwiper.on('reachEnd', function () {
            swiperWrapper.classList.add("slider-ended")
        })

        if (isMobile) {
          swiperContainer.classList.add('stars-swiper-mobile');
          collectionSwiper.destroy();
        }
    }
}

customElements.define('stars-swiper', StarsSwiper)

class ShoutoutSwiper extends HTMLElement {
    constructor() {
        super();
        const swiperContainer = this.querySelector('.shoutout-swiper')
        const shoutoutSwiper = new Swiper(swiperContainer, {
            loop: true,
            slidesPerView: 1.8,
            spaceBetween: 11,
            // slidesPerGroup: 3,

            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },

            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
                clickable: true
            },

            breakpoints: {
                480: {
                    slidesPerView: 2.3,
                    spaceBetween: 11
                },
                576: {
                    slidesPerView: 3.3,
                    spaceBetween: 15
                },
                750: {
                    slidesPerView: 4.8,
                    spaceBetween: 15,
                },
                1024: {
                    slidesPerView: 5.8,
                    spaceBetween: 28,
                }
            }
        })

        this.shoutoutVideos = Array.from(this.querySelectorAll(".favorite-shoutouts video"))
        this.shoutoutVideos.forEach((video) => {
            video.addEventListener("click", (e) => {
                var thisVid = e.target;
                if (thisVid.paused) {
                    thisVid.parentNode.classList.add('played')
                    thisVid.nextElementSibling.classList.add("played");
                    thisVid.play();
                    let sliderSiblings = getSiblings(thisVid.closest('.swiper-slide'));
                    sliderSiblings.forEach((slide) => {
                        let otherVid = slide.querySelector('.played video');
                        if (otherVid) {
                            otherVid.parentNode.classList.remove('played');
                            otherVid.nextElementSibling.classList.remove("played");
                            otherVid.pause();
                        }
                    });
                } else {
                    thisVid.parentNode.classList.remove('played')
                    thisVid.nextElementSibling.classList.remove("played")
                    video.pause()
                }
            })
        })

        let getSiblings = function(e) {
            let siblings = [];
            // if no parent, return no sibling
            if(!e.parentNode) {
                return siblings;
            }
            // first child of the parent node
            let sibling  = e.parentNode.firstChild;
            // collecting siblings
            while (sibling) {
                if (sibling.nodeType === 1 && sibling !== e) {
                    siblings.push(sibling);
                }
                sibling = sibling.nextSibling;
            }
            return siblings;
        }
    }
}

customElements.define('shoutout-swiper', ShoutoutSwiper)

class CategoriesSwiper extends HTMLElement {
    constructor() {
        super()
        const swiperContainer = this.querySelector('.categories-swiper');
        const categorySwiper = new Swiper(swiperContainer, {
            loop: true,
            slidesPerView: 1.4,
            spaceBetween: 10,

            navigation: {
                nextEl: '.swiper-button-next',
            },

            breakpoints: {
                480: {
                    slidesPerView: 2,
                    spaceBetween: 10
                },
                576: {
                    slidesPerView: 3,
                    spaceBetween: 15
                },
                768: {
                    slidesPerView: 4,
                    spaceBetween: 20,
                },
                1024: {
                    slidesPerView: 5,
                    spaceBetween: 28,
                }
            }
        })
        const pseudoBtn = this.querySelector(".swiper-button-next.pseudo");
        const realBtn = this.querySelector(".swiper-button-next.real");
        pseudoBtn.addEventListener("click", () => {
            realBtn.click()
        })

        if (isMobile) {
          swiperContainer.classList.add('swiper-mobile');
          categorySwiper.destroy();
        }
    }
}

customElements.define('categories-swiper', CategoriesSwiper)